import { render } from "./Dashboard.vue?vue&type=template&id=3aafb8d9"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jermainekelly/Developer/Client_Work/BrandedMind/Clients/Telidesk/telidesk-telinta-log-viewer/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__